var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centreContainer"},[_c('v-img',{staticClass:"mb-12",attrs:{"src":require('@/images/logo.png')}}),_c('v-card',{staticClass:"pa-8"},[_c('SignInForm',{on:{"is-authenticated":_vm.onAuthenticated}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }